import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../_globals';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../_services/notification.service';
import { KioskCategoryService } from '../_services/kiosk-category.service';
import { CookieService } from 'ngx-cookie-service';
import { TreeNode, ConfirmationService } from 'primeng/api';
import { ObjectFilterPipe } from '../_pipes/object-filter.pipe';
import { ImagesService } from '../_services/images.service';

@Component({
    selector: 'app-kiosk-categories',
    templateUrl: './kiosk-categories.component.html',
    styleUrls: ['./kiosk-categories.component.css']
})
export class KioskCategoriesComponent implements OnInit {

    @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

    kioskCategories: any[] = [];
    selectedKioskCategory = { label: 'No Kiosk Category Selected', id: null, image: null, data: { id: null, image: null } };
    selectedKioskCategoryNode: any;

    cookieStore: any;
    storeId: any;

    createKioskCategoryModal = false;
    createKioskCategoryForm: FormGroup;
    creatingKioskSubCategory = false;
    errMsgs: any[] = [];

    chooseFromImageBank = false;
    uploadNew = false;

    displayKioskCategories: TreeNode[] = [];

    editKioskCategoryForm: FormGroup;

    addMediaModal = false;
    imagesArray: any[] = [];
    selectedImage: any;
    imageBase64: any;

    constructor(
        public loader: LoadingBarService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public globals: Globals,
        public fb: FormBuilder,
        public notificationService: NotificationService,
        public _kioskCategoryService: KioskCategoryService,
        public cookieService: CookieService,
        public objectFilter: ObjectFilterPipe,
        public _imagesService: ImagesService,
        public confirmationService: ConfirmationService
    ) {
        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.createKioskCategoryForm = fb.group({
            name: new FormControl('', [Validators.required]),
            description: new FormControl(),
        });

        this.editKioskCategoryForm = fb.group({
            name: new FormControl(),
            description: new FormControl(),
            enabled: new FormControl()
        })
    }

    ngOnInit() {
        this.getAllKioskCategories();
    }

    public getAllKioskCategories() {
        this.displayKioskCategories = [];
        this._kioskCategoryService.getItemKioskCategoriesByStoreId(this.storeId)
            .subscribe((data: any) => {
                // console.log('Kiosk Categories - ', data);
                this.kioskCategories = data;
                this.filterRootItemKioskCategories(null);

            })
    }

    public populateTreeMenu(array) {
        const filteredArray = array;
        filteredArray.forEach(element => {
            // console.log(element);
            const treeNodeObject = {
                label: element.name,
                data: element,
                id: element.id,
                parent: element.parentItemCategoryId,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
                leaf: false,
                image: null,
                imageObj: null
            };
            if (element.image !== null) {
                treeNodeObject.imageObj = element.image;
                treeNodeObject.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.image.name
            };
            this.displayKioskCategories.push(treeNodeObject);
        });
    }

    public filterRootItemKioskCategories(kioskCategoryId) {
        const catId = kioskCategoryId;
        const filteredCats = this.objectFilter.transform(this.kioskCategories, 'parentItemCategoryId', catId);
        this.populateTreeMenu(filteredCats);
    }

    public loadNode(event) {
        if (event.node) {
            const parentId = event.node.data.id;
            const children = this.objectFilter.transform(this.kioskCategories, 'parentItemCategoryId', parentId);
            children.forEach(element => {
                element.label = element.name;
                element.data = element;
                element.parent = element.parentItemCategoryId;
                element.expandedIcon = 'fa fa-folder-open';
                element.collapsedIcon = 'fa fa-folder';
                element.leaf = false;
                if (element.image !== null) {
                    element.imageObj = element.image;
                    element.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.image.name;
                };
            });
            event.node.children = children;
        }
    }

    public nodeSelect(event) {
        // console.log('EVENT NODE - ', event.node.data);
        this.selectedKioskCategoryNode = event.node.data;
        this.editKioskCategoryForm.reset();
        this.editKioskCategoryForm.setValue({
            name: event.node.data.name,
            description: event.node.data.description,
            enabled: event.node.data.enabled
        })
    }

    public toggleCreateKioskCategoryModal() {
        this.createKioskCategoryModal = !this.createKioskCategoryModal;
    }

    public toggleCreateKioskSubCategoryModal() {
        this.creatingKioskSubCategory = !this.creatingKioskSubCategory;
        this.createKioskCategoryModal = !this.createKioskCategoryModal;
    }

    public onCreateKioskCategoryFormSubmit() {
        const values = this.createKioskCategoryForm.value;
        let body;
        if (this.creatingKioskSubCategory) {
            body = {
                name: values.name,
                description: values.description,
                parentItemCategoryId: this.selectedKioskCategory.data.id,
                storeId: this.storeId
            }
        } else {
            body = {
                name: values.name,
                description: values.description,
                parentItemCategoryId: null,
                storeId: this.storeId
            }
        }
        this._kioskCategoryService.createKioskCategory(body)
            .subscribe((data: any) => {
                this.createKioskCategoryForm.reset();
                if (this.creatingKioskSubCategory) {
                    this.toggleCreateKioskSubCategoryModal();
                } else {
                    this.toggleCreateKioskCategoryModal();
                }
                this.getAllKioskCategories();
                this.notificationService.notify(
                    'success',
                    'Kiosk Category Created',
                    'New Kiosk Category has successfully been created',
                    'top',
                    'right');
            })

    }

    public onEditKioskCategoryFormSubmit() {
        const values = this.editKioskCategoryForm.value;
        values.id = this.selectedKioskCategory.id;
        this._kioskCategoryService.editKioskCategory(values)
            .subscribe((data: any) => {
                // console.log(data);
                this.getAllKioskCategories();
                this.selectedKioskCategory = { label: 'No Kiosk Category Selected', id: null, image: null, data: { id: null, image: null } };
                this.notificationService.notify(
                    'success',
                    'Kiosk Category Updated',
                    'Kiosk Category has successfully been updated',
                    'top',
                    'right');
            })
    }

    // Add Media Modal
    public toggleAddMediaModal() {
        this.addMediaModal = !this.addMediaModal;
        this.getImages(this.storeId);
    }

    // Get All Images
    public getImages(id) {

        this.imagesArray = [];
        this._imagesService.getAllStoreImages(id)
            .subscribe((data: any) => {
                // console.log(data);
                data.forEach(element => {
                    const obj = {
                        imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                        src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                        thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                        imageData: element
                    };
                    this.imagesArray.push(obj);
                })
            });
    }

    public selectImageBankImage(image) {

        // console.log('selectedKioskCategory', this.selectedKioskCategory);
        // console.log('Image to attach - ', image);
        this._imagesService.addImageToKioskCategory(this.selectedKioskCategory.id, image.imageData.id)
            .subscribe((data: any) => {
                // console.log('Attach Image Response - ', data);
                if (this.selectedKioskCategoryNode.parentItemCategoryId === null) {
                    this.selectedKioskCategoryNode.image = data;
                } else {
                    this.selectedKioskCategoryNode.imageObj = data;
                }
                this.selectedKioskCategory.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.name;
                this.toggleAddMediaModal();
                this.notificationService.notify(
                    'success',
                    'Image Added',
                    'Kiosk Category Image has successfully been updated',
                    'top',
                    'right');
            });
    }

    // Uploading
    public onFileChange(event) {
        for (let i = 0; i < event.target.files.length; i++) {
            const file: File = event.target.files[i];
            const myReader: FileReader = new FileReader();
            const that = this;
            myReader.onloadend = function(loadEvent: any) {
                const fileObj = {
                    fileName: event.target.files[i].name,
                    imageBase64: loadEvent.target.result,
                    itemKioskCategoryId: that.selectedKioskCategory.id,
                    itemFeaturedItemId: null,
                    itemImageItemId: null,
                    storeFeaturedImageStoreId: null,
                    storeId: that.storeId,
                    storeLogoStoreId: null
                };
                that.imageBase64 = fileObj;
                that.uploadImage(fileObj);
            };
            myReader.readAsDataURL(file);
        }

    }

    public uploadImage(fileObj) {
        this._imagesService.uploadImageToImageBank(fileObj)
            .subscribe((data: any) => {
                this.imagesArray = [];
                this.getImages(this.storeId);
                this.selectedKioskCategory.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.name;
                this.toggleAddMediaModal();
                this.notificationService.notify(
                    'success',
                    'Image Uploaded',
                    'Image Successfully Uploaded',
                    'top',
                    'right');
            });
    }

    public removeImage(type) {
        if (type === 'parent') {
            const body = {
                imageId: this.selectedKioskCategoryNode.image.id,
                itemCategoryKioskId: this.selectedKioskCategoryNode.id
            }
            this.confirmationService.confirm({
                message: 'Are you sure that you want to remove kiosk category image? It will not be deleted from Image bank.',
                accept: () => {
                    this._imagesService.removeImageLink(body)
                        .subscribe((data: any) => {
                            // console.log(data);
                            this.selectedKioskCategory = { label: 'No Kiosk Category Selected', id: null, image: null, data: { id: null, image: null } };
                            this.getAllKioskCategories();
                        })
                }
            })
        } else {
            const body = {
                imageId: this.selectedKioskCategoryNode.imageObj.id,
                itemCategoryKioskId: this.selectedKioskCategoryNode.id
            }
            this.confirmationService.confirm({
                message: 'Are you sure that you want to remove kiosk category image? It will not be deleted from Image bank.',
                accept: () => {
                    this._imagesService.removeImageLink(body)
                        .subscribe((data: any) => {
                            // console.log(data);
                            this.selectedKioskCategory = { label: 'No Kiosk Category Selected', id: null, image: null, data: { id: null, image: null } };
                            this.getAllKioskCategories();
                        })
                }
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/kiosk-categories/kiosk-categories.component.ts